import React, { useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { apiService } from '../../services/api';
import { useToast } from '../../hooks/use-toast';

const AdminAuditLogs = () => {
  const { toast } = useToast();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const [hasSearched, setHasSearched] = useState(false);

  const loadLogs = async () => {
    if (!selectedDate) {
      toast({ title: 'Pilih tanggal', description: 'Silakan pilih tanggal audit log terlebih dahulu.', variant: 'destructive' });
      return;
    }

    setLoading(true);
    setHasSearched(true);
    try {
      const response = await apiService.admin.getAuditLogs(selectedDate, 200);
      setLogs(response.data || []);
    } catch (error) {
      const message = error?.response?.data?.detail || 'Gagal memuat audit log';
      toast({ title: 'Error', description: message, variant: 'destructive' });
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Audit Log</h2>
          <p className="text-gray-600">Riwayat perubahan sistem. Halaman ini hanya terlihat untuk Admin utama.</p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex flex-col md:flex-row md:items-end gap-3 mb-6">
            <div>
              <label htmlFor="audit-date" className="block text-sm font-medium text-gray-700 mb-2">
                Filter Tanggal
              </label>
              <input
                id="audit-date"
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                className="px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent"
              />
            </div>
            <button
              type="button"
              onClick={loadLogs}
              disabled={loading}
              className="bg-green-600 hover:bg-green-700 text-white font-medium px-4 py-2 rounded-md disabled:opacity-50"
            >
              {loading ? 'Memuat...' : 'Tampilkan'}
            </button>
          </div>

          {loading ? (
            <div className="text-gray-600">Memuat...</div>
          ) : !hasSearched ? (
            <div className="text-gray-500">Pilih tanggal lalu klik Tampilkan untuk melihat audit log.</div>
          ) : logs.length === 0 ? (
            <div className="text-gray-500">Tidak ada audit log pada tanggal yang dipilih.</div>
          ) : (
            <div className="space-y-3">
              {logs.map((log) => (
                <details key={log.id} className="border rounded-md p-4 bg-gray-50">
                  <summary className="cursor-pointer font-medium text-gray-900">
                    {log.actor_username} • {log.action} • {log.entity_type} • {new Date(log.created_at).toLocaleString('id-ID')}
                  </summary>
                  <div className="mt-3 space-y-2 text-sm text-gray-700">
                    <p><span className="font-medium">Role:</span> {log.actor_role}</p>
                    <p><span className="font-medium">Entity ID:</span> {log.entity_id || '-'}</p>
                    <pre className="bg-white border rounded p-3 overflow-x-auto text-xs">{JSON.stringify(log.changes, null, 2)}</pre>
                  </div>
                </details>
              ))}
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminAuditLogs;